import { render, staticRenderFns } from "./OrderIndex.vue?vue&type=template&id=0d99f886&"
import script from "./OrderIndex.vue?vue&type=script&lang=js&"
export * from "./OrderIndex.vue?vue&type=script&lang=js&"
import style0 from "./OrderIndex.vue?vue&type=style&index=0&id=0d99f886&prod&lang=css&"
import style1 from "./OrderIndex.vue?vue&type=style&index=1&id=0d99f886&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports